import type { MapTalesTheme } from '@fontbold/ui';
import { catalogFont, fontFaces, fontStack } from '#/lib/font-catalog';
import type { SpaceTheme } from '#/lib/queries/space';

export function toProviderTheme(theme: SpaceTheme): MapTalesTheme {
  const { accentScale } = theme;

  return {
    accentScale: {
      300: accentScale.shade300,
      400: accentScale.shade400,
      500: accentScale.shade500,
      600: accentScale.shade600,
      700: accentScale.shade700,
      tint: accentScale.tint,
    },
    secondaryScale: {
      500: theme.secondaryScale.shade500,
      tint: theme.secondaryScale.tint,
      on: theme.secondaryScale.on,
    },
    fontSans: fontStack(catalogFont(theme.fontSans)),
    fontDisplay: fontStack(catalogFont(theme.fontDisplay)),
    radius:
      theme.radius === 'Sharp'
        ? 'sharp'
        : theme.radius === 'Round'
          ? 'round'
          : 'default',
    surface:
      theme.surface === 'Warm'
        ? 'warm'
        : theme.surface === 'Cool'
          ? 'cool'
          : 'white',
  };
}

function themeFonts(theme: SpaceTheme) {
  return [...new Set([theme.fontDisplay, theme.fontSans])].map(catalogFont);
}

export function fontPreloads(theme: SpaceTheme): string[] {
  return themeFonts(theme).map((font) => font.file);
}

export function fontsCss(theme: SpaceTheme): string {
  return themeFonts(theme).map(fontFaces).join('');
}

// Keep in sync with Theme::fontBold() in maptales-api; the e2e suite compares both.
export const FONTBOLD_THEME: SpaceTheme = {
  accentScale: {
    shade300: 'oklch(0.647 0.237 267)',
    shade400: 'oklch(0.547 0.237 267)',
    shade500: '#1f3bd8',
    shade600: 'oklch(0.387 0.213 267)',
    shade700: 'oklch(0.317 0.178 267)',
    tint: 'oklch(0.96 0.04 267)',
  },
  secondaryScale: {
    shade500: '#d8f56a',
    tint: 'oklch(0.97 0.05 120)',
    on: '#0c0d10',
  },
  radius: 'Round',
  surface: 'Warm',
  fontSans: 'Inter',
  fontDisplay: 'Anton',
};
